import React, {Dispatch, SetStateAction} from "react"

export type DiscountCodeType = {
    code: string,
    discountAmount: number,
    isOrganizationDiscount: boolean,
    notApplicable: boolean,
    isMandatoryForCheckout: boolean
}

type DiscountCodeContextProviderState = {
    uid: string,
    discountCode: DiscountCodeType
    setDiscountCode:Dispatch<SetStateAction<DiscountCodeType>>
}

const DiscountCodeContext = React.createContext<DiscountCodeContextProviderState>(
	{
		uid: "",
		discountCode: {
			code: "",
			discountAmount: 0,
			isOrganizationDiscount: false,
			isMandatoryForCheckout: null,
			notApplicable: false
		},
		setDiscountCode: () => null
	}

)

export default DiscountCodeContext
